<template>
  <page>
    <template slot="content">
    <help-content :title="'利用中ペアリングが切れた場合'">
      <template slot="content">
        <div class="text">
          １．スマホのタスク画面（Androidの■ボタンをタップ／iPhoneのHomeボタンをダブルクリック）からWeRUNアプリを消してから、再度WeRUNアプリを開いてヘアリング状態を確認してください。<br><br>
          ２．スマホのBluetooth設定に表示されているWeBand（COD_BANDまたはWeRUN-????）が未接続となっている場合、それをタップし再接続してください。<br><br>
          ３．上記の操作を実施しても接続できない場合は、下記の手順で接続情報をリセットし、改めてペアリングを行います。<br>
          ※３の操作によって<b>WeBandに保存されているすべてのデータが消去される</b>ため、未同期の歩数データがあれば復元できません。ご留意ください。
        </div>
        <div class="text">
          ・WeBand側の操作<br>
          <router-link class="help-detail-link" :to="{ name: 'Help31'}">WeBand3SCのリセット</router-link>の説明に従って本体をリセットします。
        </div>
        <div class="text">
          ・アプリ側の操作<br>
          1) WeBand＞設定＞デバイス情報＞ペアリング解除を実行します。
        </div>
        <img class="picture" src="../assets/images/q_and_a/H29.png">
        <div class="text">
          2) スマホの設定＞Bluetooth画面のペアリングされたデバイスにCOD_BANDが表示されている場合、ペアリング解除を行います。
        </div>
        <img class="picture" src="../assets/images/q_and_a/H9_1.png">
      </template>
    </help-content>
    </template>
  </page>
</template>

<script>
  import HelpContent from '@/components/HelpContent'
  import Page from '@/components/Page'

  export default {
    components: {
      HelpContent,
      Page
    },
    mounted () {
      window.scrollTo(0, 0)
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Help23.vue